var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"homeLink"},[_c('df-nav-item',{attrs:{"href":_vm.unionHead.homePageUrl,"prefix-icon":_vm.bell}},[_vm._v("\n    "+_vm._s(_vm.TLang('企业首页','common'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }